import cookies from './cookies';

const modal = {
  o: {},

  init: function (){

    this.o = {
      html        : document.querySelector( 'html' ),
      pageWrapper : document.querySelector('[data-page-wrapper]' ),
      modalTrigger: document.querySelectorAll( '[data-open-modal]' ),
      modalClose  : document.querySelectorAll( '[data-close-modal]' ),
      modalTarget : document.querySelectorAll( '[data-modal]' ),
      activeModal : false,
      promoModal : false,
      newsletterId : 'modal-newsletter',
      classes: {
        layerVisible   : 'layer-visible',
        modalOpen      : 'modal-opened',
        openedModal    : 'opened-modal',
        thisOpenedModal: 'this-opened-modal',
        tabable        : 'modal-tabable',
        closeModal     : 'close-modal',
        animated       : 'modal-animated',
        innerAnimated  : 'inner-animated',
        animateOut     : 'animate-out'
      },

      helpers: { focusElements: 'a, button, input, [tabindex="0"]' }
    };

    this.initEvents();
  },

  initEvents: function (){
    this.o.modalTrigger.forEach(el => {
      el.addEventListener("click", (event) => this.onClickOpen(event) );
      this.setTriggerAria(el);
    });

    this.o.modalClose.forEach(el => {
      el.addEventListener("click", (event) => this.onClickClose(event) );
    });

    this.o.modalTarget.forEach(el => {
      el.addEventListener("click", (event) => this.overlayClick(event) );
      this.setTargetAria(el);
    });

    window.addEventListener( 'keydown', (event) => this.accessibleKeyboard(event) );

    this.initNewsletter();
  },

  initNewsletter: function (){
    const isNewsletterCookie = cookies.getCookie('newsletter');
    const isNewsletterModal = document.getElementById(this.o.newsletterId);

    if(isNewsletterCookie === null && isNewsletterModal) {
      this.openModal(this.o.newsletterId);
    }
  },

  setTargetAria: function (modalTarget){
    if ( modalTarget.classList.contains( this.o.classes.openedModal ) ) {
      this.o.html.classList.add( this.o.classes.modalOpen );
      this.o.pageWrapper.classList.add( this.o.classes.layerVisible );
      modalTarget.setAttribute( 'aria-hidden', 'false' );
    } else {
      this.o.html.classList.remove( this.o.classes.modalOpen );
      this.o.pageWrapper.classList.remove( this.o.classes.layerVisible );
      modalTarget.setAttribute( 'aria-hidden', 'true' );
    }
  },

  setTriggerAria: function (modalTrigger){
    let id = modalTrigger.getAttribute( 'data-open-modal' );

    modalTrigger.setAttribute( 'aria-haspopup', 'true');
    modalTrigger.setAttribute( 'aria-controls', id );
  },

  onClickOpen: function ( event ) {
    event.preventDefault();

    let trigger = event.currentTarget;
    let target = trigger.getAttribute( 'data-open-modal' );

    this.openModal( target );
    trigger.classList.add( this.o.classes.thisOpenedModal );

    return false;
  },

  openModal: function ( id ) {
    this.o.activeModal = document.querySelector( '#' + id );

    if(!this.o.activeModal)
      return;

    const innerModal = this.o.activeModal.querySelector( '.modal-inner' );

    this.o.html.classList.add( this.o.classes.modalOpen );
    this.o.pageWrapper.classList.add( this.o.classes.layerVisible );

    this.o.activeModal.style.display = "block";
    this.o.activeModal.setAttribute('aria-hidden', 'false');

    setTimeout( function() {
      innerModal.classList.add( modal.o.classes.innerAnimated );
    }, 0 );

    this.o.activeModal.setAttribute('tabindex', '0');
    this.o.activeModal.classList.add( this.o.classes.openedModal );
    this.o.activeModal.focus();

    this.o.activeModal.querySelectorAll( this.o.helpers.focusElements ).forEach(el => {
      el.classList.add( this.o.classes.tabable );
    });
  },

  onClickClose: function () {
    if(!this.o.activeModal)
      return;

    const innerModal = this.o.activeModal.querySelector( '.modal-inner' );
    const iframe = this.o.activeModal.querySelector( 'iframe' );

    if(this.o.activeModal.id === this.o.newsletterId)
      cookies.setCookie('newsletter', true, 30);

    if(iframe)
      iframe.setAttribute("src", "" );

    innerModal.classList.add( this.o.classes.animateOut );

    this.o.html.classList.remove( this.o.classes.modalOpen );
    this.o.pageWrapper.classList.remove( this.o.classes.layerVisible );
    this.o.activeModal.classList.remove( this.o.classes.openedModal, this.o.classes.animated );
    innerModal.classList.remove( this.o.classes.innerAnimated );

    document.querySelectorAll( '.' + this.o.classes.tabable ).forEach(el => {
      el.classList.remove( this.o.classes.tabable );
    });

    const buttonModal = document.querySelector( '.' + this.o.classes.thisOpenedModal );

    if(buttonModal) {
      buttonModal.focus();
      buttonModal.classList.remove( this.o.classes.thisOpenedModal );
    }

    // removeAria
    this.o.activeModal.style.display = "none";
    this.o.activeModal.setAttribute('aria-hidden', 'true');
    this.o.activeModal.setAttribute('tabindex', '-1');

    innerModal.classList.remove( this.o.classes.animateOut );
  },

  accessibleKeyboard: function ( event ) {
    const keyCode = event.keyCode || event.which;

    if(!this.o.activeModal)
      return;

    const tabables = this.o.activeModal.querySelectorAll( '.' + this.o.classes.tabable + ':not(:disabled)' );
    const currentFocus = document.activeElement;

    if ( keyCode === 9 ) {
      const temp_last = tabables[tabables.length - 1];

      if ( !event.shiftKey && currentFocus === temp_last )  {
        event.preventDefault();
        this.o.activeModal.querySelector( '.' + this.o.classes.closeModal ).focus();
      }

      if ( event.shiftKey && currentFocus.classList.contains( this.o.classes.closeModal ) ) {
        event.preventDefault();
        temp_last.focus();
      }
    }

    if ( keyCode === 27 ) {
      event.preventDefault();

      if ( !this.o.activeModal.getAttribute( '[data-layer-disabled]' ) )
        this.onClickClose();
    }

    if ( keyCode === 32 ) {
      const temp_for = currentFocus.getAttribute( 'for' );

      if ( temp_for ) {
        event.preventDefault();
        document.getElementById(temp_for).dispatchEvent(new CustomEvent('click'));
      }
    }
  },

  overlayClick: function ( event ) {
    let _this = event.target;

    if ( _this.hasAttribute( 'data-prevent-close' ) )
      return;

    if (_this.classList.contains(this.o.classes.openedModal))
      this.onClickClose();
  }
};

export default modal;
